import $ from 'jquery';
import _ from 'lodash';
import 'slick-carousel'

var _PostSlick = ( () =>  {
  var self = {};

  // const $posts = $('.community .posts');
  var $posts;

  var slickEnabled = false;

  self.init = (selector) => {
    $posts = $(selector);
    self.enableDisableSlick();
    window.addEventListener('resize', _.throttle(self.enableDisableSlick, 400) );
  };


  self.enableSlick = () => {
    $posts.slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      arrows:false,
      dots: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: '25%',
          }
        },
        {
          breakpoint: 450,
          settings: {
            centerPadding: '18%',
          }
        }
      ]
    });
    slickEnabled = true;
  };

  self.disableSlick = () => {
    $posts.slick('unslick');
    slickEnabled = false;
  };

  self.enableDisableSlick = () => {
    var width = $( window ).width();
    if(width >= 768 && slickEnabled) {
      self.disableSlick();
    }
    else if (width < 768 && !slickEnabled) {
      self.enableSlick();
    }
  };

  return self;
});

export default function PostSlick(selector) {
  var ps = _PostSlick();
  ps.init(selector);
}